import logoHRIQ from '@/assets/logo/logo_reciq_full.svg';

import { lead } from './lead';
import type { Brand } from './types';

export const recruitingiq: Brand = {
  ...lead,
  key: 'recruitingiq',
  appType: 'HRIQ',
  name: 'Recruiting IQ',
  shortName: 'HRIQ',
  emblem: 'HRIQ',
  logos: { main: logoHRIQ, text: logoHRIQ, panel: logoHRIQ, panelInvert: true },
  panelHeadlineKey: 'auth.panel.headline_hriq',
  theme: { sidebarBg: 'rgb(128, 128, 28)' },
};
